import { render } from "./Public.vue?vue&type=template&id=4c48c6b0&ts=true&lang=pug"
import script from "./Public.vue?vue&type=script&lang=ts"
export * from "./Public.vue?vue&type=script&lang=ts"

import "./Public.vue?vue&type=style&index=0&id=4c48c6b0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__